var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1021,
    height: 1042,
    viewBox: "0 0 1021 1042",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.504 192.584C300.093 258.553 293.39 342.977 330.019 413.613C366.642 484.225 437.148 522.868 510.886 521.14C551.307 455.155 557.99 370.756 521.363 300.126C484.745 229.497 414.244 190.879 340.502 192.588L340.504 192.584Z",
    fill: "#F8B487"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.44 231.252C257.4 302.919 264.892 386.513 313.116 448.828C361.323 511.17 437.822 536.15 510.759 521.201C539.824 449.545 532.323 365.972 484.107 303.646C435.886 241.327 359.384 216.324 286.438 231.256L286.44 231.252Z",
    fill: "#F49960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239.203 278.717C222.362 353.891 243.844 434.123 302.183 486.258C360.53 538.414 440.691 549.017 510.621 521.294C527.475 446.124 506.007 365.895 447.631 313.753C389.314 261.605 309.145 250.991 239.197 278.719L239.203 278.717Z",
    fill: "#EA573B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200.211 333.486C196.105 409.914 230.875 484.359 297.576 524.751C364.276 565.163 445.679 561.073 510.481 521.396C514.615 444.979 479.827 370.523 413.132 330.129C346.447 289.743 265.033 293.826 200.21 333.479L200.211 333.486Z",
    fill: "#E30613"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.639 393.94C179.37 469.312 226.403 535.739 299.409 563.158C372.443 590.58 452.629 571.921 510.351 521.495C501.631 446.13 454.6 379.7 381.581 352.277C308.537 324.871 228.371 343.532 170.639 393.94Z",
    fill: "#4A4D9C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.376 458.283C172.672 530.316 230.535 586.686 307.691 600.31C384.816 613.911 461.363 581.206 510.252 521.557C488.967 449.531 431.098 393.146 353.951 379.533C276.808 365.937 200.283 398.629 151.376 458.283Z",
    fill: "#424797"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.986 524.535C176.216 591.047 243.166 635.681 322.106 635.03C401.041 634.386 471.614 588.636 510.198 521.57C476.975 455.062 410.007 410.434 331.083 411.067C252.153 411.703 181.571 457.459 142.987 524.541L142.986 524.535Z",
    fill: "#2C368C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.746 590.705C189.916 649.664 263.931 681.173 342.283 666.302C420.607 651.426 483.073 594.012 510.171 521.523C466.004 462.543 391.998 431.061 313.653 445.92C235.318 460.796 172.849 518.191 145.749 590.701L145.746 590.705Z",
    fill: "#2C368C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.578 654.762C213.363 704.373 292.205 721.8 367.567 693.141C442.934 664.475 495.386 597.136 510.161 521.445C456.372 471.826 377.536 454.43 302.173 483.056C226.801 511.724 174.349 579.079 159.578 654.762Z",
    fill: "#333A8F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M184.094 714.776C245.875 753.523 327.129 756.322 397.237 714.732C467.344 673.151 508.159 597.924 510.162 521.333C448.386 482.579 367.107 479.796 297.019 521.377C226.928 562.957 186.079 638.207 184.094 714.776Z",
    fill: "#27348B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M218.544 768.898C286.435 795.582 367.676 783.663 430.367 730.399C493.058 677.152 521.008 596.346 510.145 521.199C442.243 494.508 361.013 506.434 298.335 559.684C235.651 612.946 207.677 693.749 218.545 768.904L218.544 768.898Z",
    fill: "#00983A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M261.887 815.48C333.855 829.307 412.562 803.003 465.928 739.703C519.285 676.418 533.503 592.471 510.101 521.05C438.16 507.239 359.462 533.527 306.092 596.825C252.726 660.126 238.492 744.064 261.887 815.48Z",
    fill: "#179B40"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M312.851 853.098C386.642 853.607 460.428 813.757 502.832 742.343C545.233 670.933 545.277 586.403 510.054 520.901C436.27 520.387 362.481 560.251 320.076 631.642C277.678 703.055 277.625 787.6 312.853 853.094L312.851 853.098Z",
    fill: "#47A44F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M369.802 880.595C443.178 867.807 509.797 815.599 539.936 738.209C570.09 660.887 555.967 578.359 510.01 520.77C436.609 533.565 370.006 585.788 339.869 663.125C309.728 740.477 323.842 823.011 369.804 880.591L369.802 880.595Z",
    fill: "#FFDE00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M431.041 897.149C501.756 871.431 559.165 808.44 576.162 727.522C593.122 646.592 565.277 568.586 509.983 520.664C439.251 546.377 381.844 609.364 364.855 690.303C347.882 771.214 375.719 849.216 431.039 897.143L431.041 897.149Z",
    fill: "#FFDF1F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M494.645 902.235C560.59 864.378 607.07 792.568 610.365 710.529C613.663 628.492 572.933 557.393 509.999 520.604C444.053 558.455 397.596 630.284 394.297 712.321C390.99 794.331 431.718 865.467 494.643 902.239L494.645 902.235Z",
    fill: "#FFE244"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M558.745 895.71C617.876 846.878 651.979 768.427 641.516 687.789C631.055 607.148 578.7 545.102 510.035 520.554C450.882 569.372 416.795 647.823 427.265 728.465C437.742 809.105 490.078 871.15 558.739 895.712L558.745 895.71Z",
    fill: "#FFE770"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M621.374 877.801C671.91 819.503 692.625 736.799 668.709 660.009C644.805 583.199 582.423 532.109 510.115 520.518C459.579 578.816 438.845 661.509 462.756 738.308C486.705 815.102 549.057 866.199 621.37 877.799L621.374 877.801Z",
    fill: "#FFE244"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M680.604 849.049C721.011 783.078 727.708 698.639 691.099 628.021C654.468 557.388 583.939 518.775 510.213 520.483C469.784 586.457 463.104 670.868 499.731 741.498C536.356 812.132 606.875 850.762 680.604 849.049Z",
    fill: "#FFE560"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M734.672 810.357C763.721 738.686 756.214 655.114 708.009 592.795C659.783 530.468 583.281 505.492 510.336 520.42C481.279 592.081 488.78 675.67 536.99 737.998C585.212 800.306 661.717 825.311 734.67 810.361L734.672 810.357Z",
    fill: "#FFE873"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M781.898 762.912C798.745 687.736 777.269 607.503 718.925 555.359C660.575 503.207 580.412 492.608 510.475 520.326C493.638 595.502 515.105 675.725 573.455 727.883C631.799 780.011 711.964 790.632 781.898 762.912Z",
    fill: "#FFEA82"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M820.908 708.127C825.013 631.693 790.232 557.257 723.545 516.858C656.83 476.463 575.412 480.544 510.619 520.216C506.506 596.63 541.283 671.079 607.979 711.489C674.682 751.871 756.079 747.799 820.91 708.123L820.908 708.127Z",
    fill: "#FFE97B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M850.473 647.679C841.746 572.299 794.701 505.892 721.691 478.464C648.644 451.046 568.456 469.709 510.745 520.125C519.48 595.499 566.506 661.921 639.526 689.333C712.566 716.737 792.742 698.093 850.473 647.679Z",
    fill: "#FFE560"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M869.737 583.331C848.441 511.299 790.582 454.931 713.43 441.325C636.288 427.72 559.734 460.426 510.845 520.059C532.135 592.11 590.004 648.478 667.159 662.096C744.302 675.692 820.836 642.984 869.737 583.331Z",
    fill: "#FFE34B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M878.143 517.09C844.887 450.578 777.948 405.951 699.005 406.573C620.059 407.21 549.5 452.98 510.901 520.053C544.129 586.569 611.086 631.191 690.021 630.564C768.956 629.937 839.548 584.182 878.143 517.09Z",
    fill: "#FFE024"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M875.361 450.923C831.191 391.947 757.189 360.441 678.84 375.324C600.495 390.183 538.022 447.609 510.927 520.094C555.114 579.075 629.12 610.573 707.446 595.702C785.799 580.838 848.279 523.427 875.354 450.924L875.361 450.923Z",
    fill: "#FFE02D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M861.534 386.863C807.731 337.241 728.889 319.82 653.538 348.496C578.168 377.134 525.719 444.501 510.934 520.175C564.722 569.788 643.567 587.211 718.919 558.552C794.291 529.91 846.745 462.552 861.534 386.863Z",
    fill: "#FFE34B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M837.007 326.837C775.236 288.091 693.989 285.306 623.852 326.901C553.774 368.467 512.944 443.712 510.941 520.286C572.724 559.029 653.996 561.823 724.094 520.249C794.183 478.657 835.026 403.425 837.003 326.835L837.007 326.837Z",
    fill: "#FFE97D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M802.58 272.719C734.674 246.026 653.435 257.968 590.739 311.19C528.05 364.449 500.096 445.286 510.955 520.425C578.861 547.108 660.089 535.202 722.771 481.954C785.461 428.707 813.431 347.886 802.577 272.723L802.58 272.719Z",
    fill: "#F18848"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M759.217 226.151C687.263 212.327 608.554 238.635 555.18 301.931C501.823 365.215 487.602 449.15 510.998 520.572C582.948 534.395 661.664 508.117 715.028 444.805C768.382 381.508 782.612 297.568 759.217 226.151Z",
    fill: "#F18848"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M708.256 188.528C634.477 188.006 560.678 227.853 518.284 299.268C475.897 370.687 475.833 455.226 511.05 520.713C584.84 521.242 658.635 481.376 701.044 409.971C743.43 338.568 743.489 254.031 708.259 188.531L708.256 188.528Z",
    fill: "#EA5B0C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M651.301 161.035C577.924 173.817 511.317 226.038 481.153 303.37C451.014 380.744 465.138 463.268 511.087 520.845C584.478 508.066 651.105 455.837 681.251 378.477C711.372 301.125 697.271 218.604 651.301 161.035Z",
    fill: "#EF7833"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M590.073 144.466C519.348 170.19 461.92 233.164 444.968 314.099C427.985 395.036 455.829 473.042 511.11 520.95C581.854 495.244 639.264 432.259 656.248 351.322C673.222 270.401 645.374 192.393 590.073 144.466Z",
    fill: "#F49960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M526.459 139.396C460.513 177.247 414.054 249.054 410.756 331.091C407.441 413.139 448.177 484.237 511.1 521.019C577.047 483.174 623.503 411.371 626.824 329.315C630.094 247.283 589.383 176.168 526.459 139.396Z",
    fill: "#F8B487"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M462.358 145.914C403.224 194.75 369.12 273.179 379.583 353.833C390.052 434.479 442.407 496.524 511.056 521.057C570.203 472.24 604.302 393.803 593.838 313.143C583.361 232.502 531.025 170.458 462.354 145.912L462.358 145.914Z",
    fill: "#F8B487"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M399.737 163.85C349.202 222.122 328.494 304.798 352.4 381.62C376.315 458.421 438.695 509.498 510.988 521.096C561.538 462.801 582.254 380.113 558.338 303.306C534.418 226.514 472.042 175.423 399.74 163.846L399.737 163.85Z",
    fill: "#FCD4B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.721b0dcfbb2a2940cb740e187579553c.svg";
export { ForwardRef as ReactComponent };